import React, { useEffect, useState, useRef } from "react";
import Carousel from "react-bootstrap/Carousel";
import { BsArrowLeftCircle, BsArrowRightCircle } from "react-icons/bs"; // Importing icons from react-icons
import "./Style.css";
import { IoIosArrowForward } from "react-icons/io";
import { IoIosArrowBack } from "react-icons/io";
import { Apiurl } from "../../Pages/utils/page";
const BannerPage = ({ bannerData, setBannerIdData, loading }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const carouselRef = useRef(null);

  const handleSelect = (selectedIndex) => {
    setActiveIndex(selectedIndex);
    const selectedBanner = bannerData[selectedIndex];
    if (selectedBanner) {
      setBannerIdData(selectedBanner.Id);
    }
  };
  // Variables to track swipe start and end positions
  let touchStartX = 0;
  let touchEndX = 0;
  // Functions to handle touch events
  const handleTouchStart = (e) => {
    touchStartX = e.changedTouches[0].screenX;
  };
  const handleTouchEnd = (e) => {
    touchEndX = e.changedTouches[0].screenX;
    handleSwipeGesture();
  };
  const handleSwipeGesture = () => {
    if (touchEndX < touchStartX) {
      // Swipe left, go to next slide
      const nextIndex =
        activeIndex + 1 < bannerData.length ? activeIndex + 1 : 0;
      setActiveIndex(nextIndex);
      setBannerIdData(bannerData[nextIndex]?.Id);
    }
    if (touchEndX > touchStartX) {
      // Swipe right, go to previous slide
      const prevIndex =
        activeIndex - 1 >= 0 ? activeIndex - 1 : bannerData.length - 1;
      setActiveIndex(prevIndex);
      setBannerIdData(bannerData[prevIndex]?.Id);
    }
  };
  return (
    <Carousel
      activeIndex={activeIndex}
      onSelect={handleSelect}
      className="banner_crousel_head home_banner_1"
      interval={null}
      ref={carouselRef}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
    >
      {bannerData?.map((item) => {
        const banner = item?.BannerUrl.split('"');
        const bannerUrl = `${Apiurl()}/${banner?.[1]}`;
        return (
          <Carousel.Item key={item.Id} className="Bannner-Inner-container">
            <img
              className="Banner-image"
              src={bannerUrl}
              alt={item.BusinessName}
              onError={(e) => {
                e.target.onerror = null; 
                e.target.src =
                  "/Images/banner-default.jpg"
              }}  
              layout="intrinsic"
              width={1200} // You can set appropriate width
              height={500} // You can set appropriate height
            />
          </Carousel.Item>
        );
      })}
    </Carousel>
  );
};
export default BannerPage;
